<template>
  <div>
    <h4>Pay with exisiting card</h4>
    <v-radio-group
      v-model="previousCardForPayment"
      column
      :disabled="generatingPayment"
    >
      <v-radio
        v-for="card in registrationCards"
        :key="card.registrationId"
        :label="'XXXX XXXX XXXX ' + card.last4Digits"
        :value="card.registrationId"
        color="primary"
      />
    </v-radio-group>
    <v-progress-circular
      v-if="generatingPayment"
      indeterminate
      color="primary"
      class="mx-auto"
    />
    <form
      v-if="paymentResponseForRepeatPayment.url"
      class="mb-12"
      name="submitForm"
      :action="paymentResponseForRepeatPayment.url"
      method="POST"
    >
      <input
        type="hidden"
        name="MD"
        :value="paymentResponseForRepeatPayment.MD"
      />
      <input type="hidden" name="connector" value="THREEDSECURE" />
      <input
        type="hidden"
        name="TermUrl"
        :value="paymentResponseForRepeatPayment.termUrl"
      />
      <input
        type="hidden"
        name="PaReq"
        :value="paymentResponseForRepeatPayment.paReq"
      />

      <v-btn
        type="submit"
        rounded
        depressed
        large
        color="primary"
        class="recurring-payment-button"
      >
        PAY NOW
      </v-btn>
    </form>
  </div>
</template>

<script>
  import { PAY_WITH_EXISTING_CARD_MUTATION } from '../../constants/graphql/payments';

  export default {
    name: 'RecurringPayment',
    props: {
      registrationCards: {
        required: true,
        type: Array,
      },
      paymentPlan: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        previousCardForPayment: null,
        paymentResponseForRepeatPayment: {},
        generatingPayment: false,
      };
    },
    watch: {
      previousCardForPayment: function (newValue) {
        if (newValue) {
          this.createNewPaymentWithExistingCard();
        }
      },
    },
    methods: {
      createNewPaymentWithExistingCard() {
        this.generatingPayment = true;
        this.$apollo
          .mutate({
            mutation: PAY_WITH_EXISTING_CARD_MUTATION,
            variables: {
              registrationId: this.previousCardForPayment,
              redirectUrl: window.origin + '/basic-payment',
              paymentPlan: this.paymentPlan,
            },
          })
          .then(({ data: { payWithExistingCard } }) => {
            this.paymentResponseForRepeatPayment = payWithExistingCard;
            this.generatingPayment = false;
          })
          .catch(error => {
            this.generatingPayment = false;
            console.error(error);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .recurring-payment-button {
    float: right;
  }
</style>
